import { render, staticRenderFns } from "./PassportTooSmall.vue?vue&type=template&id=d0fa8050&scoped=true"
var script = {}
import style0 from "./PassportTooSmall.vue?vue&type=style&index=0&id=d0fa8050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fa8050",
  null
  
)

export default component.exports